import { LoyaltyActionType } from '../../loyalty/shared/models/loyalty-action-type.enum';

/** Loyalty action types that are used for notifications  */
export enum NotificationLoyaltyType {
  /** Null action */
  None = LoyaltyActionType.None,

  /** Auction Outbid Action */
  AuctionOutBid = LoyaltyActionType.AuctionOutBid,

  /** Marketplace Purchase */
  MarketplaceOrderProcessed = LoyaltyActionType.MarketPlaceOrderProcessed,

  /** Voucher code entered */
  VoucherCodeEntered = LoyaltyActionType.VoucherCodeEntered,

  /** Scorecard Complete */
  ScorecardComplete = LoyaltyActionType.ScorecardComplete,

  /** Points notification */
  PointsNotification = LoyaltyActionType.PointsNotification,

  /** Ecash spend */
  EcashSpend = LoyaltyActionType.EcashSpend,

  /** Attendance Check in (from access control) */
  AttendanceCheckIn = LoyaltyActionType.AttendanceCheckIn,

  /** Answer trivia */
  AnswerTrivia = LoyaltyActionType.AnswerTrivia,

  /** Lotto won */
  LottoWon = LoyaltyActionType.LottoWon,

  /** Auction won */
  AuctionWon = LoyaltyActionType.AuctionItemWon,

  /** AuctionBidPlaced */
  AuctionBidPlaced = LoyaltyActionType.PlaceAuctionBid,

  /** Scorecard Action Complete */
  ScorecardActionComplete = LoyaltyActionType.ScorecardActionComplete,

  /** Scorecard Milestone Complete */
  ScorecardMilestoneComplete = LoyaltyActionType.ScorecardMilestoneComplete,

  /** Campaign Manager Notification */
  CampaignManagerNotification = LoyaltyActionType.CampaignManagerNotification,

  /** Scorecard Expiration Notification */
  ScorecardExpirationNotification = LoyaltyActionType.ScorecardExpirationNotification,

  /** Scorecard Activation Notification */
  ScorecardActivationNotification = LoyaltyActionType.ScorecardActivationNotification,
}
